enum ComponentsFilter {
    Hide = "hide",
    ShowConnected = "showConnected",
    ShowNotConnected = "showNotConnected",
    Show = "show"
}

export default ComponentsFilter;
